module.exports = __webpack_public_path__ + "static/media/sessions.d4677d66.svg";